import comp from "./ParentProgressReport";
export default comp;
